(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-quotes"] && !Shopify.designMode) return;
  try {
    
  /* Mobile carousel: let the track follow the height of the card in view */
  (function () {
    var mq = window.matchMedia('(max-width: 749px)');
    document.querySelectorAll('.book-quotes__list').forEach(function (list) {
      var items = Array.prototype.slice.call(list.querySelectorAll('.book-quotes__item'));
      var ticking = false;
      function current() {
        var x = list.scrollLeft, best = items[0], bestD = Infinity;
        items.forEach(function (el) {
          var d = Math.abs(el.offsetLeft - list.offsetLeft - x);
          if (d < bestD) { bestD = d; best = el; }
        });
        return best;
      }
      function fit() {
        ticking = false;
        if (!mq.matches) { list.style.height = ''; return; }
        var card = current().firstElementChild;
        if (card) list.style.height = card.getBoundingClientRect().height + 'px';
      }
      function schedule() { if (!ticking) { ticking = true; requestAnimationFrame(fit); } }
      var settle;
      function onScroll() { clearTimeout(settle); settle = setTimeout(fit, 90); }
      if ('onscrollend' in window) {
        list.addEventListener('scrollend', fit);
      } else {
        list.addEventListener('scroll', onScroll, { passive: true });
      }
      list.addEventListener('click', function () { setTimeout(fit, 0); });
      window.addEventListener('resize', schedule);
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(fit); }
      window.addEventListener('load', fit);
      fit();
    });
  })();
  document.querySelectorAll('.book-quotes__item--long .book-quotes__card').forEach(function (card) {
    card.addEventListener('click', function () {
      card.closest('.book-quotes__item').classList.toggle('is-open');
    });
  });
  document.querySelectorAll('.book-quotes__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var section = btn.closest('.book-quotes');
      var expanded = section.classList.toggle('book-quotes--expanded');
      btn.setAttribute('aria-expanded', String(expanded));
      btn.textContent = expanded ? btn.dataset.less : btn.dataset.more;
      if (!expanded) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
